import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import { LoraTable } from '../interfaces/lora-table';
import { LoraDevices } from '../interfaces/lora-devices';
import { LoraReceipt } from '../interfaces/lora-receipt';
import { Constants } from './constants-service'
import { AuthenticationService } from './authentication-services'
import { ErrorHandlerService } from './error.handler.service';

@Injectable()
export class HttpServices {

    constructor (private http: HttpClient,
                 private constant: Constants,
                 private authenticationService: AuthenticationService,
                 private errHand: ErrorHandlerService) { }

    getDeviceLoraTable(idDevice, dateFrom, dateTo, allDevices): Observable<LoraTable[]> {
      dateFrom = dateFrom.toLocaleString('ru-RU', {year: 'numeric', month: 'numeric', day: 'numeric'})
        .split('.').reverse().join('-');
      dateTo = dateTo.toLocaleString('ru-RU', {year: 'numeric', month: 'numeric', day: 'numeric'})
        .split('.').reverse().join('-')
      const params: HttpParams  = new HttpParams()
      .set('from', dateFrom)
      .set('to', dateTo)
      .set('allDevices', allDevices);

      const tableGetURL: string = this.constant.deviceInf + '/api/applications/' + this.constant.applicationID +
      '/nodes/' + idDevice + '/volumes/dates';

        return this.http.get(tableGetURL, {params: params})
          .map((resp: LoraTable[]) => {
            const dataResponse: LoraTable[] = resp || [];
            dataResponse.sort((a, b) => {
              return b.modTime - a.modTime;
            });
            dataResponse.forEach((item) => {
              const dataPreFormat = new Date(Number(item.dt0 * 1000));
              const dataModFormat = new Date(Number(item.modTime * 1000));
              const dataDTSFormat = new Date(Number(item.dts * 1000));
              item.dt0 = dataPreFormat.toLocaleString('ru', {
                timeZone: 'UTC',
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric' } );
              item.dts = dataDTSFormat.toLocaleString('ru', {
                timeZone: 'UTC',
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'} );
              item.modTime = dataModFormat.toLocaleString('ru', {
                timeZone: 'UTC',
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
              } );
            });
            const column: LoraTable[] = dataResponse;
            return column;
            })
          .catch((error: any) => this.errHand.handlerEror(error));
    };


    getDevice(): Observable<LoraDevices> {
      const params  = new URLSearchParams();
      params.set('limit', this.constant.limit);
      const listGetDevices: string = this.constant.listDevices + '/api/applications/' +
                          this.constant.applicationID + '/nodes';
        return this.http.get(listGetDevices)
          .map((resp: LoraDevices) => resp)
          .catch((error: any) => this.errHand.handlerEror(error));
    }

    setConfigDevice(idDevice, deviceBody) {

      const tableGetURL: string = this.constant.setCongigDevice + '/api/applications/' + this.constant.applicationID +
        '/nodes/' + idDevice + '/receipts';

      return this.http.post(tableGetURL, deviceBody)
        .map(resp => resp)
        .catch((error: any) => this.errHand.handlerEror(error));
    }
    // [UMKA] остановить ожидание ответа от устройчства
    stopWiting(eui) {
      return this.http.delete(this.constant.setCongigDevice + '/api/stop/' + eui)
        .map(resp => resp)
        .catch((error: any) => this.errHand.handlerEror(error));
    }
  getAllReceipts(): Observable<LoraReceipt[]> {

    const listReceipt: string = this.constant.setAllReceipt + '/api/applications/' +
      this.constant.applicationID + '/nodes/receipts';

    return this.http.get(listReceipt)
      .map((resp: Array<LoraReceipt>) => {
        const dataResponse: Array<LoraReceipt> = resp || [];
        dataResponse.forEach(function (item) {
        item.createtime = item.createtime.replace('T', '  ')
      });
        dataResponse.sort(function (a, b) {
        return b.idrec - a.idrec;
      });
        return dataResponse;
      })
      .catch((error: any) => this.errHand.handlerEror(error));
  }
  getReceiptDetail(receiptID) {
    // getReceiptDetail
    const receiptById: string = this.constant.getReceiptDetail + '/api/applications/' +
      this.constant.applicationID + '/nodes/receipts/' + receiptID;

    return this.http.get(receiptById)
      .map(resp => resp)
      .catch((error: any) => this.errHand.handlerEror(error))

  }

  getAlltickets() {
    const tickket: string = this.constant.getReceiptDetail + '/api/tickets';
    return this.http.get(tickket).map(resp => resp)
  }

  getInfoServices() {

    const infoService: string = this.constant.getInfoService + '/api/applications/' + this.constant.applicationID +
      '/nodes/audits/';

    return this.http.get(infoService)
      .map(resp => resp)
      .catch((error: any) => this.errHand.handlerEror(error))
  }

  getInfoServicesSelectedDevice (euiDevice) {

    const infoServiceSelectedDevice: string = this.constant.getInfoServiceSelected + '/api/applications/' + this.constant.applicationID +
      '/nodes/audits/' + euiDevice + '/keys';

    return this.http.get(infoServiceSelectedDevice)
      .map(resp => resp)
      .catch((error: any) => this.errHand.handlerEror(error))
  }



  // getCurentToken () {
  //   const headers: HttpHeaders = new HttpHeaders()
  //     .append('Authorization', 'Bearer' + '')
  //     .append('Content-Type', 'application/json');
  //   return headers;
  // }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/services/http-services.ts